import Skeleton, { SkeletonProps } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export interface SkeletonCustomProps extends SkeletonProps {
    theme?: string;
    className?: string;
}

export function SkeletonCustom(props: SkeletonCustomProps) {
    return (
        <Skeleton
            baseColor={props.theme === 'light' ? 'var(--gray-50)' : 'var(--gray-900)'}
            highlightColor={props.theme === 'light' ? 'white' : 'var(--gray-700)'}
            {...props}
        />
    );
}

SkeletonCustom.defaultProps = {
    theme: 'light',
};

export default SkeletonCustom;
